import DataTable from "@/components/DataTable/DataTable";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant/userRole";
import { Button, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const UserDetails = () => {
  // const userDetails = useSelector((state) => state?.user?.userDetails);
  const navigate = useNavigate();
  const params = useParams("userId");
  const userId = params.userId;

  const [user, setUser] = useState({});

  const getUser = async () => {
    const response = await axios.get(`/user/` + userId, { withCredentials: true });
    if (response) {
      setUser(response.data);
    }
  };

  useEffect(() => {
    document.title = `${appConfig.name} - ${getHeader(user?.role).title}`;
    getUser();
  }, []);

  const getHeader = (role) => {
    switch (role) {
      case "installer":
        return {
          title: "Installer Profile",
        };
      case "admin":
        return {
          title: "Site Admin Profile",
        };
      case "user":
        return {
          title: "Site User Profile",
        };
      case "public":
        return {
          title: "Public User Profile",
        };
      case userRole.businessAdmin:
        return {
          title: "Business Admin Profile",
        };
      default:
        return {
          title: "User Profile",
        };
    }
  };

  const columns = [
    {
      title: "No",
      width: "100px",
      render: (row, item, index) => index + 1,
    },
    {
      title: "Site Location",
      render: (row) => (
        <Link to={`/site-locations/details/` + row?._id} className="me-2">
          {row.name}
        </Link>
      ),
    },
    {
      title: "Business",
      render: (row) => (
        <div>
          {row?.businesses?.name}({row?.businesses?.id})
        </div>
      ),
    },
    {
      title: "Date Assigned",
      render: () => moment(user.updatedAt).format("DD/MM/YYYY"),
    },
  ];

  return (
    <div className="card p-3 m-md-3">
      <label className="az-content-label mb-3">{getHeader(user?.role).title}</label>
      <div className="row mt-4 gy-4 mb-5">
        <div className="col-md-8">
          <div className="row mb-2">
            <div className="col-4">Full Name</div>
            <div className="col-8">: {user?.name}</div>
          </div>
          <div className="row mb-2">
            <div className="col-4">Email Address</div>
            <div className="col-8">: {user?.email}</div>
          </div>
          <div className="row mb-2">
            <div className="col-4">Phone Number</div>
            <div className="col-8">: +6{user?.phone}</div>
          </div>

          <div className="row mb-2">
            <div className="col-4">Status</div>
            <div className="col-8">
              :{" "}
              {typeof user?.isActive === "boolean" ? (
                user?.isActive ? (
                  <Tag color="success">Active</Tag>
                ) : (
                  <Tag color="error">Deactivated</Tag>
                )
              ) : (
                ""
              )}
            </div>
          </div>
          {/* {["businessAdmin"].includes(user?.role) && ( */}
          <>
            <div className="row mb-2">
              <div className="col-4">Business</div>
              <div className="col-8">
                {user?.business?.map((b, ind) => (
                  <div key={b._id}>
                    {ind === 0 ? (
                      `: ${b?.name} (${b?.id})`
                    ) : (
                      <span className="ps-2">
                        {" "}
                        {b?.name} ({b?.id})
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </>
          {/* <div className="row mb-2">
            {userDetails?.role === userRole.superAdmin && (
              <>
                {user?.urlLogin && (
                  <div className="col-12 mt-5">
                    <CopyToClipboard
                      text={`${window.location.origin}/url-login/${user._id}`}
                      onCopy={() => {
                        message.info({
                          content: "Login URL copied!",
                          duration: 3,
                          top: 50,
                        });
                      }}
                    >
                      <Button type="primary">Copy Login URL</Button>
                    </CopyToClipboard>
                  </div>
                )}
              </>
            )}
          </div> */}
          {/* // )} */}
        </div>
        <div className="col-md-4 text-md-center">
          <span className="text-center d-inline-block">
            {user?.avatar && (
              <img
                src={user?.avatar}
                alt="logo"
                className="rounded-circle img-responsive"
                style={{ height: "150px" }}
              />
            )}
            <div className="col-12 mt-3">Profile Photo</div>
          </span>
        </div>
      </div>

      {["user", "public", "admin", "installer", "businessAdmin"].includes(user?.role) && (
        <div className="row mb-2">
          <div className="col-12">
            <DataTable
              columns={columns}
              dataSource={user?.site}
              pagination={{
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                pageSizeOptions: [10, 20, 50],
                responsive: true,
              }}
            />
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-md-12 d-flex justify-content-end">
          <Link to={`/users/edit/` + userId}>
            <Button type="primary">Edit</Button>
          </Link>

          <Button type="primary" className="bg-secondary ms-2" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
